import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'

const Home = () => {

    const testiSlider = {
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 2500,
        speed: 600,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false
                },
            },
        ],
    }

    return (
        <>
            <section className="main_slider">
                <div className="social_sidebar wow animate__animated animate__slideInRight" data-wow-delay="0.1s" data-wow-duration="2s">
                    <h5>FOLLOW ON</h5>
                    <div className="social_line" />
                    <ul className="social_icons">
                        <li><Link to="#"><i className="fa-brands fa-instagram" /></Link></li>
                        <li><Link to="#"><i className="fa-brands fa-x-twitter" /></Link></li>
                        <li><Link to="#"><i className="fa-brands fa-facebook-f" /></Link></li>
                        <li><Link to="#"><i className="fa-brands fa-linkedin-in" /></Link></li>
                    </ul>
                </div>
                <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div className="bnr_bg">
                                <img src="images/bnr.png" className="img-fluid" alt="..." />
                            </div>
                            <div className="carousel-caption">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className=" col-lg-6 col-md-8 col-sm-4 align-self-center">
                                            <div className="banner_text wow animate__animated animate__slideInLeft" data-wow-delay="0.3s" data-wow-duration="1s">
                                                <h1><span>
                                                    Grow Your
                                                </span>
                                                    Own Space</h1>
                                                <h4>Connecting Spare Land with People Who Want to Grow</h4>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                                    tempor incididunt ut labore et dolore magna aliqua. </p>
                                                <Link to="/booking" className="theme_btn1">
                                                    <div className="theme-btn-inner1">
                                                        <div className="btn-text1">Request a Free Quote</div>
                                                        <div className="btn-img1"><img src="images/btn-img2.png" alt />
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <div className="bnr_bg">
                                <img src="images/bnr.png" className="img-fluid" alt="..." />
                            </div>
                            <div className="carousel-caption">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className=" col-lg-6 col-md-8 col-sm-4 align-self-center">
                                            <div className="banner_text">
                                                <h1><span>
                                                    Grow Your
                                                </span>
                                                    Own Space</h1>
                                                <h4>Connecting Spare Land with People Who Want to Grow</h4>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                                    tempor incididunt ut labore et dolore magna aliqua. </p>
                                                <Link to="/booking" className="theme_btn1">
                                                    <div className="theme-btn-inner1">
                                                        <div className="btn-text1">Request a Free Quote</div>
                                                        <div className="btn-img1"><img src="images/btn-img2.png" alt />
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="slider_btns wow animate__animated animate__slideInLeft" data-wow-delay="0.1s" data-wow-duration="2s">
                        <button className="slide-btn prev" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                            <i className="fa-solid fa-caret-left" />
                        </button>
                        <div className="divider" />
                        <button className="slide-btn next" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                            <i className="fa-solid fa-caret-right" />
                        </button>
                    </div>
                </div>
            </section>
            <section className="about all-section">
                <div className="container">
                    <div className="row justify-content-end">
                        <div className="col-lg-10">
                            <div className="about_left">
                                <img src="images/abt-2.jpg" alt />
                            </div>
                            <div className="about_right">
                                <h2 className="wow animate__animated animate__slideInRight" data-wow-delay="0.2s" data-wow-duration="1s">
                                    About
                                    <span>
                                        Spareland
                                    </span>
                                </h2>
                                <div className="abt_right_img">
                                    <img src="images/abt-1.jpg" alt />
                                    <div className="abt_txt wow animate__animated animate__slideInRight" data-wow-delay="0.3s" data-wow-duration="1s">
                                        <p>Lorem ipsum dolor sit amet, elit, sed do eiusmod tempor incididunt ut labore et
                                            dolore magna aliqua. </p>
                                        <p>
                                            Duis aute irure dolor in reprehenderit in voluptataboreet dolore magna aliqua. Ut
                                            enim ad minim ve lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                                            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                            quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
                                            duis aute irure dolor in reprehenderit in voluptat dolore magna aliqua. Ut enim ad
                                            minim ve lorem
                                        </p>
                                        <Link to="/about-us" className="theme_btn1">
                                            <div className="theme-btn-inner1">
                                                <div className="btn-text1">Read MOre</div>
                                                <div className="btn-img1"><img src="images/btn-img2.png" alt />
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="service all-section-btm">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12 wow animate__animated animate__fadeInDown" data-wow-delay="0.3s" data-wow-duration="2s">
                            <div className="heading">
                                <h2>
                                    Available Allotments
                                </h2>
                                <p>
                                    Duis aute irure dolor in reprehenderit in voluptataboreet dolore magna aliqua. Ut enim ad
                                    minim ve lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                    incididunt
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay="0.4s" data-wow-duration="2s">
                            <div className="service_main">
                                <img src="images/s-1.jpg" alt />
                                <div className="svr_no">
                                    01
                                </div>
                                <div className="service_txt">
                                    <h3>Interior &amp; Exterior Painting</h3>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                    </p>
                                    <ul className="srv_disnone">
                                        <li>
                                            <img src="images/full-size.png" alt />
                                            <span>
                                                100 – 250 sqm
                                            </span>
                                        </li>
                                        <li>
                                            <img src="images/location.png" alt />
                                            <span>
                                                Demo Allotment Plot 2 45 Meadow Vie....
                                            </span>
                                        </li>
                                    </ul>
                                    <Link to="/find-land-detail" className="srv_btn">
                                        <span>
                                            MOre Detail
                                        </span>
                                        <img src="images/btn-img2.png" alt />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay="0.5s" data-wow-duration="2s">
                            <div className="service_main">
                                <img src="images/s-2.jpg" alt />
                                <div className="svr_no">
                                    02
                                </div>
                                <div className="service_txt">
                                    <h3>Cabinet &amp; Brick Painting</h3>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempoLorem
                                        ipsum dolor sit amet, consectetur adipisicing
                                    </p>
                                    <ul className="srv_disnone">
                                        <li>
                                            <img src="images/full-size.png" alt />
                                            <span>
                                                100 – 250 sqm
                                            </span>
                                        </li>
                                        <li>
                                            <img src="images/location.png" alt />
                                            <span>
                                                Demo Allotment Plot 2 45 Meadow Vie....
                                            </span>
                                        </li>
                                    </ul>
                                    <Link to="/find-land-detail" className="srv_btn">
                                        <span>
                                            MOre Detail
                                        </span>
                                        <img src="images/btn-img2.png" alt />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay="0.6s" data-wow-duration="2s">
                            <div className="service_main">
                                <img src="images/s-3.jpg" alt />
                                <div className="svr_no">
                                    03
                                </div>
                                <div className="service_txt">
                                    <h3>Texture &amp; Surface Repairs</h3>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                    </p>
                                    <ul className="srv_disnone">
                                        <li>
                                            <img src="images/full-size.png" alt />
                                            <span>
                                                100 – 250 sqm
                                            </span>
                                        </li>
                                        <li>
                                            <img src="images/location.png" alt />
                                            <span>
                                                Demo Allotment Plot 2 45 Meadow Vie....
                                            </span>
                                        </li>
                                    </ul>
                                    <Link to="/find-land-detail" className="srv_btn">
                                        <span>
                                            MOre Detail
                                        </span>
                                        <img src="images/btn-img2.png" alt />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="spare_land">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12  wow animate__animated animate__fadeInDown" data-wow-delay="0.3s" data-wow-duration="2s">
                            <div className="spare_land_content">
                                <h2>List Your Spare Land</h2>
                                <p>
                                    Duis aute irure dolor in reprehenderit in voluptataboreet dolore magna aliqua. Ut enim ad
                                    minim ve lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                    incididunt
                                </p>
                                <Link to="/booking" className="theme_btn1">
                                    <div className="theme-btn-inner1">
                                        <div className="btn-text1">Register Your Land</div>
                                        <div className="btn-img1"><img src="images/btn-img2.png" alt />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="wcu all-section">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="wcu_left wow animate__animated animate__slideInLeft" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div className="wcu_left_img">
                                    <img src="images/wcu-1.jpg" alt />
                                </div>
                                <div className="wcu_left_txt">
                                    <h2>
                                        Unlock the<span className="d_block" />
                                        Potential of Your Land
                                    </h2>
                                    <div className="wcu_padding">
                                        <p>Duis aute irure dolor in reprehenderit in voluptataboreet dolore magna aliqua. Ut
                                            enim ad
                                            minim ve lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                            tempor
                                            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                                            exercitation ullamco laboristempor incididunt ut labore et dolore magna aliqua. Ut
                                            enim
                                            ad minim veniam, quis </p>
                                        <ul>
                                            <li>
                                                Spare Land connects unused land with people who want to grow.
                                            </li>
                                            <li>
                                                We help solve the UK allotment shortage.
                                            </li>
                                            <li>
                                                Landowners can list plots easily and securely.
                                            </li>
                                            <li>
                                                Growers can find and rent space near them quickly.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="wcu_right wow animate__animated animate__slideInRight" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div className="wcu_right_txt">
                                    <h2>
                                        Why Choose <span className="d_block" />
                                        spareland
                                    </h2>
                                    <p>
                                        Lorem ipsum dolor sit amet, elit, sed do eiusmod tempor incididunt ut labore et dolore
                                        magna aliqua dummy here lorem.
                                    </p>
                                    <p>
                                        Duis aute irure dolor in reprehenderit in voluptataboreet dolore magna aliqua. Ut enim
                                        ad minim ve lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                                        nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat duis aute
                                        irure dolor in reprehenderit in voluptat
                                    </p>
                                    <Link to="/about-us" className="theme_btn1">
                                        <div className="theme-btn-inner1">
                                            <div className="btn-text1">learn more</div>
                                            <div className="btn-img1"><img src="images/btn-img2.png" alt />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="wcu_right_img">
                                    <img src="images/wcu-1.jpg" alt />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="testimonial all-section-btm">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12 wow animate__animated animate__fadeInDown" data-wow-delay="0.3s" data-wow-duration="2s">
                            <div className="heading">
                                <h2>happy clients</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                                    labore et dolore magna aliqua. Quis ipsum suspeno eiusmod tempor incididunt ut lab
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="testi_slider">
                        <Slider {...testiSlider}>
                            <div>
                                <div className="testi_box">
                                    <div className="quote">
                                        <i className="fa-solid fa-quote-right" />
                                    </div>
                                    <div className="testimonial_main">
                                        <ul>
                                            <li>
                                                <h3>Selena Clark</h3>
                                                <h6>Manger</h6>
                                            </li>
                                            <li>
                                                <div className="rating">
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                            incididunt
                                            ut labore et dolore magna aliqua Ut enim ad minim.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="testi_box">
                                    <div className="quote">
                                        <i className="fa-solid fa-quote-right" />
                                    </div>
                                    <div className="testimonial_main">
                                        <ul>
                                            <li>
                                                <h3>Selena Clark</h3>
                                                <h6>Manger</h6>
                                            </li>
                                            <li>
                                                <div className="rating">
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                            incididunt
                                            ut labore et dolore magna aliqua Ut enim ad minim.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="testi_box">
                                    <div className="quote">
                                        <i className="fa-solid fa-quote-right" />
                                    </div>
                                    <div className="testimonial_main">
                                        <ul>
                                            <li>
                                                <h3>Selena Clark</h3>
                                                <h6>Manger</h6>
                                            </li>
                                            <li>
                                                <div className="rating">
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                            incididunt
                                            ut labore et dolore magna aliqua Ut enim ad minim.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="testi_box">
                                    <div className="quote">
                                        <i className="fa-solid fa-quote-right" />
                                    </div>
                                    <div className="testimonial_main">
                                        <ul>
                                            <li>
                                                <h3>Selena Clark</h3>
                                                <h6>Manger</h6>
                                            </li>
                                            <li>
                                                <div className="rating">
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                            incididunt
                                            ut labore et dolore magna aliqua Ut enim ad minim.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="testi_box">
                                    <div className="quote">
                                        <i className="fa-solid fa-quote-right" />
                                    </div>
                                    <div className="testimonial_main">
                                        <ul>
                                            <li>
                                                <h3>Selena Clark</h3>
                                                <h6>Manger</h6>
                                            </li>
                                            <li>
                                                <div className="rating">
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                            incididunt
                                            ut labore et dolore magna aliqua Ut enim ad minim.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Home